import React, { useEffect, useState } from 'react';
import * as R from 'ramda';

export const CustomBase = ({title, description, customeComponent, index, expanded, branch, setSelectedNonOption, globalPayload, disableModifications}) => {
    const [show, setShow] = useState(expanded);
    useEffect(() => {
        if (!R.isNil(expanded)) {
            if (!R.isNil(branch.serviceId)) {
                setShow(expanded);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expanded]);
    let titleWithNoSpaces = title.replace(/ /g,'') + "showInput" + index;

    let oui = show !== undefined && show === true ? true: false;
    let non = show !== undefined && show === false ? true: false;

    useEffect(() => {
        if (!R.isNil(show)) {
            setSelectedNonOption(show === false ? true : false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    return (
        <div className="block" >
            <div className="grid grid-md-2 align-items-center mb-sm">
                <div className="mr-auto">
                    <h5 className={"h4 text-uppercase text-secondary font-weight-black my-auto"}>{title}</h5>
                </div>
                <div className="flex-row ml-auto align-items-center">
                    {/* <div className="form-inline mb-3"> */}
                        <div className="custom-control custom-radio custom-control-inline" >
                            <input required={show === undefined ? true : false} type="radio" id={'Oui' + titleWithNoSpaces} name={'Oui' + titleWithNoSpaces} onClick={() => setShow(true)} onChange={() => {}} className="custom-control-input" checked={oui} disabled={disableModifications && !R.isNil(globalPayload.id)}  />
                            <label className="custom-control-label" htmlFor={'Oui' + titleWithNoSpaces}>Oui</label>
                        </div>
                        <div className="custom-control custom-radio custom-control-inline mr-0" >
                            <input required={show === undefined ? true : false} type="radio" id={'Non' + titleWithNoSpaces} name={'Non' + titleWithNoSpaces} onClick={() => setShow(false)} onChange={() => {}} className="custom-control-input" checked={non} disabled={disableModifications && !R.isNil(globalPayload.id)}  />
                            <label className="custom-control-label" htmlFor={'Non' + titleWithNoSpaces}>Non</label>
                            
                        </div>
                    {/* </div> */}
                    {/* <button type="button" className="btn btn-icon p-1 align-middle o-0 mx-auto" onClick={() => setShow(!show)} ><i className="eva eva-edit-2-outline align-middle fs-lead"></i></button> */}
                    {/* <div className="custom-control custom-switch mx-auto">
                        <input type="checkbox" className="custom-control-input" id={titleWithNoSpaces} onChange={() => setShow(!show)} defaultChecked={show} />
                        <label className="custom-control-label" htmlFor={titleWithNoSpaces}>{show ? 'Oui' : 'Non'}</label>
                    </div> */}
                </div>
            </div>
            {(show === true && description !== undefined) ? <p className="small font-weight-regular mt-nsm mb-sm">Mentionnez le numéro que vous avez. Le numéro de chacun est facultatif.</p> : ''}
            {
                show ?
                    customeComponent
                :
                    ''
            }
        </div>
    )
}